/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import React from "react";
import {
    Button,
    Form,
    Grid,
    Header,
    Image,
    Message,
    Segment,
} from "semantic-ui-react";

const FirstStepLogin = ({
    isDarkTheme,
    credentials,
    error,
    handleChange,
    clickLoginButton,
}) => (
    <Grid
        className={isDarkTheme ? "login-dark" : "login-light"}
        textAlign="center"
        style={{ height: "100vh", margin: 0 }}
        verticalAlign="middle"
    >
        <Grid.Column style={{ maxWidth: 450 }}>
            <Image src="/static/logo.png" centered alt="" />
            <Header as="h2" color="blue" textAlign="center">
                Log-in to your account
            </Header>
            <Form size="large">
                <Segment stacked>
                    <Form.Input
                        fluid
                        icon="user"
                        iconPosition="left"
                        placeholder="Login"
                        name="login"
                        value={credentials.login}
                        onChange={handleChange}
                        error={error.login}
                    />
                    <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder="Password"
                        type="password"
                        name="password"
                        value={credentials.password}
                        onChange={handleChange}
                        error={error.password}
                    />

                    <Button
                        color="blue"
                        fluid
                        size="large"
                        onClick={clickLoginButton}
                    >
                        Login
                    </Button>
                    <div style={{ marginTop: "5px" }}>
                        <a href={"/auth/password-reset/"}>Forgot password?</a>
                    </div>
                </Segment>
            </Form>
            {/* <Message>
						<Link to={'/registration'}>Registration</Link>
					</Message> */}
            {error.wrongCredentials ? (
                <Message negative>
                    <p>Wrong login/password</p>
                </Message>
            ) : null}
        </Grid.Column>
    </Grid>
);

export default FirstStepLogin;
